<div style="font-size:0.3rem;color: white">正在跳转中...</div>
<!--<div id="tip1" class="tip">-->
  <!--<p class="fontSize16 lineHeight21">请先完成能力诊断</p>-->
  <!--<button id="quitBtn" class="btnWord" (click)="showPreSurvey()">立即前往</button>-->
<!--</div>-->



// WEBPACK FOOTER //
// ./src/app/learning-map-open-class.component.html